var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCatalog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8376 7.16331V2.55844H19.2901C19.3264 2.55832 19.3616 2.57103 19.3895 2.59432C19.4174 2.61761 19.4362 2.64999 19.4426 2.68576V7.16331H14.8376ZM14.8376 13.3044V8.69858H19.4426V13.3035L14.8376 13.3044ZM19.4426 14.8397V19.2912C19.4423 19.3318 19.4261 19.3706 19.3974 19.3993C19.3687 19.428 19.3298 19.4443 19.2892 19.4446H14.8376V14.8397H19.4426ZM13.3014 14.8397V19.4446H8.69573V14.8397H13.3014ZM13.3014 8.69858V13.3035H8.69573V8.69765L13.3014 8.69858ZM13.3014 2.55844V7.16331H8.69573V2.55844H13.3014ZM7.16037 2.55844V7.16331H2.55542V2.70898C2.55542 2.66832 2.57159 2.62932 2.60034 2.60056C2.6291 2.5718 2.66813 2.55566 2.7088 2.55566L7.16037 2.55844ZM7.16037 8.69858V13.3035H2.55542V8.69765L7.16037 8.69858ZM7.16037 14.8397V19.4446H2.7088C2.66829 19.4446 2.62953 19.4285 2.6008 19.4C2.57207 19.3714 2.55567 19.3326 2.55542 19.2921V14.8397H7.16037Z",
    fill: "#006AED"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalog);
export default __webpack_public_path__ + "static/media/catalog.664c7703c2f2643d886a197129bb1c31.svg";
export { ForwardRef as ReactComponent };